// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"db990897","239":"761b1e97","732":"5b187515"}[chunkId] + ".chunk.js";
};